import React from 'react'

import WithdrawalRateSlider from './WithdrawalRateSlider'

const App = props => {
  const { contentLeft, contentRight } = props.content
  return (
    <div className='withdrawal-rate-slider-wrapper u-sizeConstrained u-paddingHoriz14gu u-bgColorLight'>
      <WithdrawalRateSlider contentLeft={contentLeft} contentRight={contentRight} />
    </div>
  )
}

export default App
